import { useCallback, useMemo } from 'react';
import { DropdownWithChildrenProps } from '../types';
import { useDropdownWithChildrenContext } from '../context';

type UseFetchMoreOptionsArgs = Pick<
  DropdownWithChildrenProps,
  'initialLimit' | 'optionsTotalCount' | 'options' | 'onOptionsFetchMore'
>;

type UseFetchMoreOptionsResult = {
  handleOptionsFetchMore: () => void;
};

const useFetchMoreOptions = ({
  initialLimit,
  optionsTotalCount,
  options,
  onOptionsFetchMore,
}: UseFetchMoreOptionsArgs): UseFetchMoreOptionsResult => {
  const { searchInputValue } = useDropdownWithChildrenContext();

  const handleOptionsFetchMore = useCallback((): void => {
    const hasNextOffset = options.length < optionsTotalCount;
    const nextOffset = Math.floor(options.length / initialLimit) + 1;

    if (!hasNextOffset) return;

    onOptionsFetchMore?.(searchInputValue, nextOffset, initialLimit).catch((error) =>
      console.error(error, 'onOptionsFetchMore')
    );
  }, [searchInputValue, initialLimit, optionsTotalCount, options.length, onOptionsFetchMore]);

  return useMemo(
    () => ({
      handleOptionsFetchMore,
    }),
    [handleOptionsFetchMore]
  );
};

export default useFetchMoreOptions;
